import { render, staticRenderFns } from "./NavbarComponent.vue?vue&type=template&id=05fafb3a&scoped=true"
import script from "./NavbarComponent.js?vue&type=script&lang=js&external"
export * from "./NavbarComponent.js?vue&type=script&lang=js&external"
import style0 from "./NavbarComponent.vue?vue&type=style&index=0&id=05fafb3a&prod&lang=scss&scoped=true"
import style1 from "./NavbarComponent.vue?vue&type=style&index=1&id=05fafb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fafb3a",
  null
  
)

export default component.exports